import React, { useEffect, useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import { AppDispatch, RootState } from '../../redux/store/appStore';
import { useDispatch, useSelector } from 'react-redux';
import { getProject } from '../../redux/slices/projectSlice/addProjectSlice';
import { useParams } from 'react-router-dom';
import { all } from 'axios';

type CardContent = {
  [key: string]: {
    description: string[];
    status: string;
  };
};
interface ChooseTypeAllocationProps {
  selectedType: string | null;
  onTypeClick: (type: string) => void;
  activeStep: number;
  onDoubleClick: (step: number) => void;
  allocationType?: any;
  taskerType?: any
}

const ChooseTypeAllocation: React.FC<ChooseTypeAllocationProps> = ({ selectedType, onTypeClick, activeStep, onDoubleClick, allocationType, taskerType }) => {
  const [keyword, setKeyword] = useState('');
  const [cardContent, setCardContent] = useState<CardContent>({
    'Type 1': {
      description: [
        'This includes Task those are COMPLETED, ACTIVE, NOT STARTED, or Pending for REVIEW assign them to email IDs easily.',
      ],
      'status': 'enable'
    },
    'Type 2': {
      description: [
        "Unallocation done by entering email IDs and the number of tasks, and it'll only affect tasks that have not been started.",
      ],
      'status': 'enable'
    },
    'Type 3': {
      description: [
        'Allocation/Unallocation by uploading a sheet with task IDs, email IDs, and counts.',
      ],
      'status': 'enable'
    }
  });


  const getTypeBoxStyles = (type: string, state: string) => ({
    cursor: state === 'enable' ? 'pointer' : 'not-allowed',
    background: selectedType === type
      ? 'linear-gradient(135deg, #4A90E2, #50B6FF)'
      : 'linear-gradient(135deg, #D9EAF9, #ECF5FF)',
    borderColor: selectedType === type ? '#4A90E2' : '#E0E0E0',
    boxShadow: selectedType === type
      ? '0 8px 16px rgba(74, 144, 226, 0.4)'
      : '0 4px 8px rgba(0, 0, 0, 0.1)',
    color: selectedType === type ? '#fff' : '#1E2C38',
    transition: 'all 0.3s ease',
    width: 300,
    height: 200,
    borderRadius: 4,
    padding: '24px',
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  });

  const getIconButtonStyles = (type: string) => ({
    backgroundColor: selectedType === type ? '#ffffff33' : '#F0F0F0',
    transition: 'background-color 0.3s ease',
  });

  const iconMap: Record<string, React.ReactNode> = {
    'Type 1': <LooksOneIcon />,
    'Type 2': <LooksTwoIcon />,
    'Type 3': <Looks3Icon />
  };

  const typeTitles: Record<string, string> = {
    'Type 1': 'Task Selection',
    'Type 2': 'Task Count',
    'Type 3': 'Task IDs'
  };

  const association_type = useSelector((state: RootState) => state.projects.association_type);
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();

  useEffect(() => {
    dispatch(getProject({ project_id: id }))
  }, [id])

  const typesToShow = (
    (taskerType === 'UNALLOCATION' || allocationType === 'allocation')
      ? ['Type 1', 'Type 3']
      : (taskerType === 'vendorAllocation')
        ? ['Type 2', 'Type 3']
        : ['Type 1', 'Type 2', 'Type 3']
  ).filter(type => !(association_type === 'VENDOR' && type === 'Type 3'));
  // const typesToShow = (allocationType === 'unallocation' ? ['Type 1', 'Type 2'] : ['Type 1', 'Type 2', 'Type 3'])
  //   .filter(type => !(association_type === 'VENDOR' && type === 'Type 3'));

  useEffect(() => {
    const extractKeywordFromURL = (): string => {
      const url = window.location.href;

      const path = url.split('?')[0];
      const pathSegments = path.split('/');
      const lastPathSegment = pathSegments[pathSegments.length - 1];

      const queryPart = url.split('?')[1];
      const lastQuerySegment = queryPart ? queryPart.split('&').pop() : '';

      return decodeURIComponent(lastQuerySegment || lastPathSegment || '');
    };

    const currentKeyword = extractKeywordFromURL();
    setKeyword(currentKeyword);
  }, []);

  useEffect(() => {
    if (keyword) {
      const updatedCardContent = { ...cardContent };

      switch (keyword) {
        case 'Unallocation':
          updatedCardContent['Type 1'].description = [
            'Selected task will be unallocated',
          ];
          updatedCardContent['Type 2'].description = [
            'Unallocation of tasks that have not been started by entering email IDs and task numbers.',
          ];
           updatedCardContent['Type 3'].description = [
            'Unallocate tasks of all statuses using an Excel or CSV file with columns: Task ID, Stage ID, and Expert ID, Role.',
          ];
          break;

        case 'vendorbulkallocation':
          updatedCardContent['Type 2'].description = [
            'Allocate tasks directly by selecting stages, vendors, and entering the task count to the vendor on the platform.',
          ];
          updatedCardContent['Type 3'].description = [
            'Allocate tasks using an Excel or CSV file with columns: Task ID, Stage ID, and Vendor ID to the vendor.',
          ];
          break;

          case 'vendorbulkunallocation':
          updatedCardContent['Type 2'].description = [
            'Unallocate tasks with only statuses Not started, NOT allocated directly by selecting stages, vendors, statuses and entering the task count from the vendor. ',
          ];
          updatedCardContent['Type 3'].description = [
            'Unallocate tasks of all statuses using an Excel or CSV file with columns: Task ID, Stage ID, and Vendor ID from the vendor.',
          ];
          break;

        case 'Task Allocation':
          updatedCardContent['Type 3'].description = [
            "Allocate tasks by uploading a sheet with task name's.",
          ];
          break;
        case 'Review Allocation':
          updatedCardContent['Type 1'].description = [
            'Review allocations by selecting tasks in COMPLETED, ACTIVE, NOT STARTED, or pending review status and assigning to email IDs.',
          ];
          break;
        case 'Review Unallocation':
          updatedCardContent['Type 1'].description = [
            'Review unallocations by selecting and modifying tasks based on their status.',
          ];
          break;
        default:
          console.log('Unknown keyword:', keyword);
      }
      setCardContent(updatedCardContent);
    }
  }, [keyword]);
  const getIconForType = (type: string): React.ReactNode => {
    if (keyword === 'vendorbulkallocation' || keyword === 'vendorbulkunallocation') {
      if (type === 'Type 2') return iconMap['Type 1'];
      if (type === 'Type 3') return iconMap['Type 2'];
    }
    if (keyword === 'Task Allocation' || keyword === 'Unallocation') {
      if (type === 'Type 3') return iconMap['Type 2'];
    }

    return iconMap[type];
  };

  return (
    <Box display="flex" justifyContent={allocationType === 'unallocation' || association_type === 'VENDOR' ? 'space-evenly' : 'space-evenly'} mt={10} gap={2} mx={12}>
      {typesToShow.map((type) => {
        return (
          <Box
            key={type}
            sx={getTypeBoxStyles(type, cardContent[type as keyof CardContent]?.status)}
            {...(cardContent[type as keyof CardContent]?.status == 'enable' && { 'onClick': () => onTypeClick(type) })}
            {...(cardContent[type as keyof CardContent]?.status == 'enable' && { 'onDoubleClick': () => onDoubleClick(activeStep + 1) })}
          >
            <IconButton
              style={getIconButtonStyles(type)}
              size="large"
              sx={{
                color: selectedType === type ? '#ffffff' : '#4A90E2',
                fontSize: '480px',
                backgroundColor: selectedType === type ? '#ffffff33' : '#F0F0F0',
                transition: 'background-color 0.3s ease',
              }}
            >
              {getIconForType(type)}
            </IconButton>
            <Typography variant="h6" mt={2} fontFamily="Poppins" fontWeight={700}>
              {typeTitles[type]}
            </Typography>
            {cardContent[type as keyof CardContent]?.description.map((point: string, index: number) => (
              <Typography
                key={index}
                variant="body2"
                color={selectedType === type ? '#fff' : '#1E2C38'}
                mb={1}
                sx={{ display: 'flex', alignItems: 'center', fontFamily: 'Montserrat', fontSize: '10px', fontWeight: 600, marginTop: '0px' }}
              >
                <Box
                  component="span"
                  sx={{
                    width: 0,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: selectedType === type ? '#fff' : '#4A90E2',
                    mr: 1,
                  }}
                />
                {point}
              </Typography>
            ))}
          </Box>
        )
      })}
    </Box>
  );
};

export default ChooseTypeAllocation;
